import { Component, OnInit, Input } from '@angular/core';
import { HighlightService } from 'src/app/core/services/highligh.service';

@Component({
  selector: 'app-code-render-tabs',
  templateUrl: './code-render-tabs.component.html',
  styleUrls: ['./code-render-tabs.component.scss'],
})
export class CodeRenderTabsComponent implements OnInit {
  @Input() data: any;
  @Input() idComponent: string = '';
  public highlighted: boolean = false;

  constructor(private highlightService: HighlightService) {}

  ngOnInit(): void {
    // This is intentional
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
}
